// TODO: remove lodash once we have a real API
import { get } from 'lodash';
import logger from '@/utils/logger.mjs';

export type SortType = 'asc' | 'desc';

/**
 * Compare different types of values
 * https://reacthustle.com/blog/typescript-sort-array-of-objects-by-property
 *
 * @param property
 * @param sortOrder
 */
export function createCompareFn<T extends Object>(
  property: keyof T,
  sortOrder: SortType
) {
  return (a: T, b: T) => {
    const val1 = get(a, property);
    const val2 = get(b, property);
    const order = sortOrder !== 'desc' ? 1 : -1;

    if (!(val1 || val2)) {
      return 0;
    }
    if (!val1) {
      return -1;
    }
    if (!val2) {
      return 1;
    }

    const valType = typeof val1;

    switch (valType) {
      case 'number': {
        const result = (val1 as number) - (val2 as number);
        return result * order;
      }
      case 'string': {
        const valb = val2 as string;
        const result = (val1 as string).localeCompare(valb);
        return result * order;
      }
      case 'object': {
        const valClass = val1.constructor.name;
        switch (valClass) {
          case 'Date': {
            const vala = val1 as unknown as Date;
            const valb = val2 as unknown as Date;
            return (vala.getDate() - valb.getDate()) * order;
          }
          default: {
            logger.warn('No comparator for ', valClass);
            return 0;
          }
        }
      }
      // add other cases like boolean, etc.
      default: {
        logger.warn('No comparator for', typeof val1);
        return 0;
      }
    }
  };
}
